import React from 'react';
import { paymentStatusOptions, PaymentStatusType } from '../../api/reservation/reservation.types';
import {WithTranslation, withTranslation} from 'react-i18next';

interface ReservationPaymentStatusLabelProps extends WithTranslation {
  status: PaymentStatusType;
}

const WARING_STATUSES_LIST = [
  PaymentStatusType.FAILED,
  PaymentStatusType.COLLECTION_FAILED,
  PaymentStatusType.MPI_TOKEN_FAILED,
  PaymentStatusType.MPI_VALIDATION_FAILED,
  PaymentStatusType.PREAUTH_FAILED,
  PaymentStatusType.REFUND_FAILED,
  PaymentStatusType.CANCELLATION_FAILED,
  PaymentStatusType.DECLINED
];

class ReservationPaymentStatusLabel extends React.PureComponent<ReservationPaymentStatusLabelProps> {

  getColor = () => {
    if (this.props.status === PaymentStatusType.COLLECTED) return 'success';
    if (WARING_STATUSES_LIST.find((s) => s === this.props.status)) return 'danger';

    return 'secondary';
  };

  render() {
    const status = paymentStatusOptions.find((o) => o.value === this.props.status);

    return (
      <div className={`text-${this.getColor()}`}>{status ?  this.props.t(status.label as keyof Translation) :
          this.props.status}</div>
    );
  }
}

export default withTranslation()(ReservationPaymentStatusLabel);
